import React from 'react';
import { IconProps } from './types';

const PersonWithBlueBackground: React.FC<IconProps> = props => {
  const { size = 68 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      // {...props}
    >
      <g filter="url(#a)">
        <rect width={60} height={60} x={4} y={2} fill="#E0EFFF" rx={8} />
      </g>
      <mask
        id="b"
        width={40}
        height={40}
        x={14}
        y={12}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha'
        }}
      >
        <path fill="#D9D9D9" d="M14 12h40v40H14z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#025ECB"
          d="M29 45.334h-6.667a3.21 3.21 0 0 1-2.354-.98A3.21 3.21 0 0 1 19 42.002V18.667c0-.916.326-1.701.98-2.354a3.21 3.21 0 0 1 2.353-.979h23.334a3.21 3.21 0 0 1 2.354.98A3.21 3.21 0 0 1 49 18.666v23.334a3.21 3.21 0 0 1-.98 2.354 3.21 3.21 0 0 1-2.353.979H39l-3.833 3.833a1.463 1.463 0 0 1-.542.355c-.194.069-.403.104-.625.104-.222 0-.43-.035-.625-.104a1.463 1.463 0 0 1-.542-.355L29 45.334Zm5-13.333c1.611 0 2.986-.57 4.125-1.709 1.139-1.139 1.708-2.514 1.708-4.125 0-1.61-.57-2.986-1.708-4.125-1.139-1.139-2.514-1.708-4.125-1.708-1.611 0-2.986.57-4.125 1.708-1.139 1.14-1.708 2.514-1.708 4.125 0 1.611.57 2.986 1.708 4.125 1.139 1.14 2.514 1.709 4.125 1.709ZM22.333 42h23.334v-1.917a16.8 16.8 0 0 0-5.23-3.48c-1.986-.846-4.131-1.27-6.437-1.27s-4.451.424-6.438 1.27a16.8 16.8 0 0 0-5.229 3.48v1.917Z"
        />
      </g>
      <defs>
        <filter
          id="a"
          width={68}
          height={68}
          x={0}
          y={0}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13892_217384" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_13892_217384" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default PersonWithBlueBackground;
